import { render, staticRenderFns } from "./AdditionalFileUploader.vue?vue&type=template&id=1e4c7274"
import script from "./AdditionalFileUploader.vue?vue&type=script&lang=js"
export * from "./AdditionalFileUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports